<template>
    <li :class="[$style['mds-list-group__item'], classObject]" :data-mds-version="version">
        <template v-if="sublist">
            <input
                type="checkbox"
                :class="[$style['mds-list-group__toggle-input']]"
                :id="`mds-list-group__toggle-input-${toggleId}`"
                :checked="toggleActive"
            />
            <label :for="`mds-list-group__toggle-input-${toggleId}`" :class="[$style['mds-list-group__toggle']]">
                <mds-icon
                    v-if="iconLeft"
                    :name="iconLeft"
                    :class="[$style['mds-list-group__left-icon']]"
                    :size="iconSize"
                />
                <mds-icon
                    :class="[$style[('mds-icon', 'mds-list-group__toggle-icon')]]"
                    name="triangle-fill-down"
                    title="triangle-fill-down"
                    size="small"
                />
                <span :class="[$style['mds-list-group__toggle-text']]">
                    {{ text }}
                </span>
                <slot name="mds-list-item-right" />
            </label>
            <slot />
        </template>
        <template v-else>
            <component
                :is="dynamicComponent"
                :href="href"
                :class="[$style['mds-list-group__link'], imageClass]"
                :aria-disabled="disabled"
                :tabindex="spanIndex"
            >
                <mds-icon
                    v-if="iconLeft"
                    :name="iconLeft"
                    :class="[$style['mds-list-group__left-icon']]"
                    :size="iconSize"
                ></mds-icon>
                <img
                    v-if="image"
                    :class="[$style['mds-list-group__item-image'], imageRoundClass]"
                    :src="image"
                    aria-hidden="true"
                />
                <span :class="[$style['mds-list-group__item-text']]">
                    <slot>{{ text }}</slot>
                    <span v-if="metadata" :class="[$style['mds-list-group__item-metadata']]" v-html="metadata"></span>
                    <slot name="mds-list-item-microcopy">
                        <span
                            v-if="microcopy"
                            :class="[$style['mds-list-group__item-microcopy']]"
                            v-html="microcopy"
                        ></span>
                    </slot>
                    <span
                        v-if="metadataBelow && metadataBelow.length"
                        :class="[$style['mds-list-group__item-metadata-below']]"
                    >
                        <span
                            v-for="(item, index) in metadataBelow"
                            :key="`metabelow-${index}`"
                            v-html="item"
                            :class="[$style['mds-list-group__item-metadata-below-item']]"
                        ></span>
                    </span>
                </span>

                <slot name="mds-list-item-right" />
                <div
                    v-if="parentVariation.variationObj === 'navigation' && active"
                    :class="[$style['mds-list-group__active-indicator']]"
                />
                <mds-icon
                    v-if="parentVariation.variationObj === 'selection' && active"
                    name="check"
                    :class="[$style['mds-list-group__active-icon']]"
                    :size="iconSize"
                />
            </component>
        </template>
    </li>
</template>

<script>
    import MdsIcon from '@mds/icon';

    // Import component's API
    import MdsListGroupItemProps from './list-group-item_props.js';

    export default {
        name: 'MdsListGroupItem',
        components: {
            MdsIcon,
        },
        model: {
            prop: 'toggleActive',
            event: 'input',
        },
        inject: ['parentVariation'], // Properties that are provided via ancestor components https://vuejs.org/v2/api/#provide-inject
        props: MdsListGroupItemProps,
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style['mds-list-group__item--sublist']] = this.sublist;
                obj[this.$style['mds-list-group__item--active']] = this.active;
                obj[this.$style['mds-list-group__item--disabled']] = this.disabled;
                obj[this.$style['mds-list-group__item--separator-before']] = this.separatorBefore;

                return obj;
            },
            dynamicComponent() {
                return this.href ? 'a' : 'span';
            },
            iconSize() {
                return this.size === 'small' || this.size === 'medium' ? 'small' : 'medium';
            },
            imageClass() {
                return this.image ? this.$style['mds-list-group__link--with-image'] : '';
            },
            imageRoundClass() {
                return this.imageRound ? this.$style['mds-list-group__item-image--round'] : '';
            },
            spanIndex() {
                return this.href ? null : 0;
            },
        },
        data: () => {
            return {
                toggleId: '',
                inputId: '',
                size: null,
            };
        },
        methods: {
            randomNum(max = 1000000000000000) {
                return Math.floor(Math.random() * Math.floor(max));
            },
            bindEventHandlers() {
                this.$el.addEventListener('click', event => {
                    this.$emit('mds-list-item-clicked', event.currentTarget, event);
                });
            },
        },
        mounted() {
            this.toggleId = this.randomNum();
            this.inputId = this.randomNum();
            this.size = this.parentVariation.size;
            this.bindEventHandlers();
        },
    };
</script>

<style lang="scss" module>
    @import './list-group.scss';
</style>
